import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

/** Utilities */
import { encryptUrlData } from "../../services/CryptoService";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import ProjectCard from "../../components/projectCard/ProjectCard";

/** RTK Query */
import { useLazyGetAllProjectDetailsQuery } from "../../app/services/projectOverviewAPI";

const ProjectOverview = () => {

  const [projectDetails, setProjectDetails] = useState([])

  const navigate = useNavigate();

  const [getAllProjectDetails, {
    isLoading: isListLoading,
    isFetching: isListFetching,
    isSuccess: isListSuccess,
    data: allProjectsData,
  },] = useLazyGetAllProjectDetailsQuery();

  useEffect(() => {
    if (!isListFetching && isListSuccess && allProjectsData) {
      setProjectDetails(allProjectsData);
    }
  }, [isListFetching, isListSuccess, allProjectsData]);

  useEffect(() => {
    getAllProjectDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigation = (project) => {
    if (project.projectId) {
      const requestURL = {
        projectId: project.projectId,
        projectCode: project.projectCode,
        projectName: project.projectName,
      }
      navigate(`/projectOverviewdetails/${encryptUrlData(requestURL)}`)
    }
  }

  return (
    <div className="team-overview-section center-top-space">
      <div className="row team-overview-gap">
        <CardSection cardTitle={"Projects"} isContentLoading={isListLoading}>
          <div className="row">
            {projectDetails.map((project) => (
              <ProjectCard
                cardColumns={3}
                project={project}
                key={project.projectId}
                onNavigation={handleNavigation}
              />
            ))}
          </div>
        </CardSection>
      </div>
    </div>
  );
};

export default ProjectOverview;
